export default "<html>\n    <head>\n        <title></title>\n    </head>\n    <body>\n        <div>Hello world.</div>\n    </body>\n</html>";